import { ExpensesState } from 'src/types/redux';
import {
  ExpensesActionType,
  FETCH_EXPENSES_FAILURE,
  FETCH_EXPENSES_REQUEST,
  FETCH_EXPENSES_SUCCESS,
} from '../types/expensesTypes';

const initialState: ExpensesState = {
  error: '',
  loading: false,
  expensesTotal: 0,
  expensesData: [],
  expensesPagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

export const expensesReducer = (
  state = initialState,
  action: ExpensesActionType
): ExpensesState => {
  switch (action?.type) {
    case FETCH_EXPENSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_EXPENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        expensesData: action?.payload.data,
        expensesPagination: action?.payload.pagination,
        expensesTotal: action?.payload.expensesTotal,
      };
    case FETCH_EXPENSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
